// hooks/useSubscriptionUpdate.ts
import { useState } from 'react';
import { updateStripeSubscriptionV2 } from '@api-service/checkout';
import { triggerToast } from '@components/atoms/toast';
import { UpdateSubscriptionPayload } from 'types/subscription';

export const useSubscriptionUpdate = (
  accessToken: string | null,
  router: any
) => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');

  const updateSubscription = async (payload: UpdateSubscriptionPayload) => {
    if (!payload.tier?.trim() || !payload.term?.trim()) {
      setError('Missing subscription information');
      return false;
    }

    if (!accessToken) {
      setError('Missing subscription information');
      return false;
    }

    try {
      setPending(true);
      setError('');

      const response = await updateStripeSubscriptionV2({
        payload,
        accessToken
      });

      if (response.hasChangedPlan) {
        triggerToast({
          title: 'Success',
          subTitle: 'Plan successfully changed',
          variant: 'success'
        });
        router.push('/auth/logout');
        return true;
      }

      if (response.error) {
        throw new Error(response.error);
      }

      return false;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to update subscription';
      setError(errorMessage);
      return false;
    } finally {
      setPending(false);
    }
  };

  return {
    updateSubscription,
    pending,
    error,
    setPending,
    setError
  };
};
